<template>
  <div
    id="rewards"
    :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }"
  >
    <header-o :model="headerData"></header-o>
    <div
      class="margin-vertical-10"
      :style="[
        isGamification
          ? { 'margin-top': '-70px' }
          : showActionButton || rewardsShowCurrencyList
          ? { 'margin-top': '-84px' }
          : { 'margin-top': '-142px' }
      ]"
    >
      <div
        v-if="refer_code != null"
        class="scratch-card-container bg-light radius-5 padding-0510 box-shadow margin-bottom-10"
      >
        <div class="align-hor center-ver flex-09 space-between">
          <div class="align-hor center-ver flex-09">
            <div
              class="radius50 align-hor center-ver center-hor opc-80 margin-right-10"
              style="width: 35px; height: 35px"
              :style="{ backgroundColor: bgTheme }"
            >
              <img class="smaller-icon" src="@/assets/share.svg" />
            </div>
            <div class="text-left">
              <div class="text-medium font-bold">{{ refer_code }}</div>
              <div class="text-small">Your referral code</div>
            </div>
          </div>
          <div
            @click="getShareMsg(null, 'wa')"
            class="text-regular pointer"
            :style="{ color: bgTheme }"
          >
            Share
          </div>
        </div>
      </div>

      <!-- Toast Notification for Gift Card Initiated -->
      <transition name="fade">
        <div v-if="showRedeemToast" class="toast" style="z-index: 90">
          <!-- 🎉 Gift Card Initiated Successfully! -->
          {{ redeemMessageToast }}
        </div>
      </transition>

      <div
        id="copied-toast"
        class="font-bold pos-fixed pos-center-hor pull-down"
        style="
          width: 100px;
          padding: 5px;
          border-radius: 10px;
          background: rgba(0, 0, 0, 0.3);
          margin-bottom: 70px;
          color: white;
          display: none;
        "
      >
        Link Copied
      </div>

      <div
        class="scratch-card-container bg-light padding-151 box-shadow margin-bottom-10"
        style="min-height: 240px;"
        :style="{
          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
          borderRadius: '10px'
        }"
        v-if="allUserOffers.length || showShimmer"
      >
        <div class="sc-wrapper" v-if="allUserOffers.length">
          <div
            class="scratch-card sc-wrap pos-rel margin-bottom-15 radius-10"
            :style="[
              uo.is_scratched
                ? ''
                : {
                    background: isDarkTheme ? scratchCardBgColor : bgTheme
                  }
            ]"
            v-for="(uo, i) in allUserOffers"
            style="margin: 0 5px 10px"
            :key="i"
          >
            <div
              v-if="
                (uo.voucher && uo.voucher.is_expired) ||
                  (uo.sc_data && uo.sc_data.is_expired)
              "
              class="expired-text-sc"
              @click="showScratchCard(uo)"
              style="color: #373535;"
            >
              EXPIRED
            </div>
            <div
              @click="showScratchCard(uo)"
              :style="
                !uo.is_scratched
                  ? 'height:85%'
                  : windowWidth < 511
                  ? 'height:100%;min-height:170px'
                  : windowWidth < 321
                  ? 'heigth:100%; min-height:150px'
                  : 'height: 100%;min-height:140px'
              "
            >
              <div v-if="!uo.is_scratched">
                <img class="full-width opc-25" src="@/assets/sc-bg.svg" />
                <div
                  class="radius50 pos-abs pos-center-ver pos-center-hor align-hor center-ver center-hor"
                  style="height: 70px; width: 70px"
                  :style="{
                    background: isDarkTheme ? scratchCardInnerColor : darkerBg
                  }"
                >
                  <img class="w25 opc-80" src="@/assets/medal-white.svg" />
                </div>
                <!-- Unlock Text Overlay -->
                <div
                  v-if="uo.locked"
                  class="unlock-text-label"
                  :style="{
                    backgroundColor:
                      !uo.locked && !uo.unlock_message ? 'transparent' : 'white'
                  }"
                >
                  {{ uo.unlock_message }}
                </div>
              </div>
              <!-- Expired Tag -->
              <div class="expired-tag" v-else>
                <!-- Unlock Text Overlay -->
                <div
                  v-if="
                    (uo.voucher && uo.voucher.is_expired) ||
                      (uo.sc_data && uo.sc_data.is_expired)
                  "
                  class="expired-text"
                >
                  EXPIRED
                </div>
                <div style="z-index: 0">
                  <img
                    class="w25 opc-80 margin-bottom-10 iftest"
                    :src="
                      uo.reward_logo
                        ? uo.reward_logo
                        : asset('reward.svg')
                    "
                    v-if="
                      uo.reward_type !== 'Stamps' ||
                        uo.reward_type !== 'Vouchers'
                    "
                  />
                  <!-- <img
                    class="w25 opc-80 margin-bottom-10 elsetest"
                    :src="uo.reward_logo"
                    v-if="uo.reward_type === 'Stamps'"
                  /> -->
                </div>
                <div style="color: #373535;" v-if="uo.reward_type != 'Stamps'">
                  {{ formatReward(uo.reward_type, uo.value, true, uo) }}
                </div>
                <div v-else>{{ uo.reward_title }}</div>
              </div>
            </div>
            <transition name="fade">
              <div class="overlay" v-if="uo.show_sc">
                <div
                  class="text-light"
                  style="
                    height: 100vh;
                    overflow: scroll;
                    display: flex;
                    flex-direction: column;
                  "
                >
                  <div
                    class="scratch-reward"
                    style="display: flex; justify-content: end; width: 100%"
                  >
                    <img
                      src="@/assets/close.svg"
                      class="w10 pointer"
                      v-on:click="hideScratchCard(uo)"
                      style="padding: 10px"
                    />
                  </div>
                  <div
                    class="align-ver center-ver center-hor"
                    :style="{
                      ...(uo.voucher
                        ? {
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }
                        : {})
                    }"
                  >
                    <div style="width: 100%;">
                      <div
                        class="offer-desc margin-bottom-20"
                        :style="{
                          color: isDarkTheme ? headingTextColor : '#ffffff'
                        }"
                      >
                        {{ uo.earned_for }}
                      </div>
                      <div
                        style="display: flex; justify-content: center; align-items: center;"
                        v-if="!uo.is_scratched"
                      >
                        <scratch-card
                          :key="renderCount"
                          :cardWidth="cardWidth"
                          :cardHeight="cardHeight"
                          :finishPercent="finishPercent"
                          :imageBg="isDarkTheme ? scratchCardBgColor : bgTheme"
                          :imageUrl="imageUrl"
                          :imageDarkBg="darkerBg"
                          :brushUrl="brushUrl"
                          :forceReveal="forceReveal"
                          :isLocked="uo.locked"
                          :unlockMessage="uo.unlock_message"
                          @complete="onComplete(uo)"
                        >
                          <div style="width: 100%; display: flex; justify-content: center;">
                            <img
                              class="opc-80 11"
                              style="width: 60px; height: 60px; object-fit: contain;"
                              :src="
                                uo.reward_logo
                                  ? uo.reward_logo
                                  : asset('reward.svg')
                              "
                              v-if="
                                (uo.reward_type !== 'Stamps' &&
                                  uo.value !== 0) ||
                                  uo.reward_type === 'Vouchers'
                              "
                            />
                            <img
                              class="opc-80 22"
                              style="width: 60px; height: 60px; object-fit: contain;"
                              :src="uo.reward_logo"
                              v-if="
                                uo.reward_type === 'Stamps' && uo.value !== 0
                              "
                            />

                            <!-- <img
                            class="w25 opc-80 33"
                            style="width: 40%"
                            :src="
                              uo.reward_logo
                                ? uo.reward_logo
                                : asset('sad.png')
                            "
                            v-if="
                              (uo.reward_type !== 'Stamps' && uo.value === 0) ||
                                uo.reward_type === 'Vouchers'
                            "
                          /> -->
                          </div>
                          <div>
                            <div
                              class="text-center text-grey font-bold"
                              style="font-size: 16px"
                              v-if="
                                uo.value > 0 &&
                                  (uo.reward_type !== 'Stamps' ||
                                    uo.reward_type !== 'Vouchers')
                              "
                            >
                              {{
                                formatReward(uo.reward_type, uo.value, true, uo)
                              }}
                            </div>
                            <div
                              class="text-center text-grey text-large"
                              v-if="
                                uo.is_scratched &&
                                  uo.value === 0 &&
                                  (uo.reward_type !== 'Stamps' ||
                                    uo.reward_type !== 'Vouchers')
                              "
                            >
                              Better luck next time
                            </div>
                            <div
                              v-if="uo.reward_type === 'Stamps'"
                              class="text-center text-grey font-bold"
                              style="font-size: 16px"
                            >
                              {{ uo.reward_title }}
                            </div>
                          </div>
                        </scratch-card>
                      </div>
                      <div
                        v-else
                        style="display: flex; justify-content: center; align-items: center; width: 100%;"
                      >
                        <div
                          class="card-content bg-light radius-30"
                          style="position: relative; background-color: #f7f7f7;"
                        >
                          <div
                            v-if="
                              (uo.voucher && uo.voucher.is_expired) ||
                                (uo.sc_data && uo.sc_data.is_expired)
                            "
                            style="
                              position: absolute;
                              top: 70;
                              left: 73;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              z-index: 10;
                              width: 100%;
                            "
                            :style="`height:${cardHeight}px;`"
                          >
                            <span
                              style="
                                background-color: #ffffff;
                                width: 100%;
                                padding: 5px 0px;
                                color: #373535;
                                background-color: #e3f7ff;
                              "
                              >EXPIRED</span
                            >
                          </div>
                         
                          <div class="margin-bottom-20">
                            <img
                              class="w25 opc-80 111"
                              style="width: 60px; height: 60px; object-fit: contain;"
                              :src="
                                uo.reward_logo
                                  ? uo.reward_logo
                                  : asset('reward.svg')
                              "
                              v-if="
                                uo.reward_type === 'Stamps' && uo.value == 0
                              "
                            />

                            <img
                              class="w25 opc-80 222"
                              style="width: 40%"
                              :src="
                                uo.reward_logo
                                  ? uo.reward_logo
                                  : asset('sad.png')
                              "
                              v-else-if="
                                uo.reward_type !== 'Stamps' && uo.value === 0
                              "
                            />

                            <img
                              class="w25 opc-80 333"
                              :src="
                                uo.reward_logo
                                  ? uo.reward_logo
                                  : asset('reward.svg')
                              "
                              v-else
                            />
                          </div>

                          <p
                            v-if="uo.reward_type !== 'Stamps' && uo.value === 0"
                            style="margin: 0px; color: #373535;"
                          >
                            Better luck next time
                          </p>

                          <div
                            class="text-center text-grey font-bold"
                            style="font-size: 16px;"
                            v-if="
                              (uo.value > 0 && uo.reward_type !== 'Stamps') ||
                                uo.reward_type !== 'Vouchers'
                            "
                          >
                            <!-- {{
                              formatReward(uo.reward_type, uo.value, true, uo)
                            }}33 -->
                          </div>
                          <!-- <div
                            class="text-center text-grey text-large"
                            v-if="
                              uo.value === 0 && uo.reward_type === 'Cash'
                              uo.value === 0
                               &&
                                (
                                  uo.reward_type !== 'Stamps' ||
                                  uo.reward_type !== 'Vouchers')
                            "
                          >
                            Better luck next time-3
                          </div> -->
                          <div
                            v-if="uo.reward_type === 'Stamps' || 'Vouchers'"
                            class="text-center text-grey font-bold"
                            style="font-size: 16px"
                          >
                            {{ uo.reward_title }}
                          </div>
                          <!-- <div
                             v-if="uo.reward_type !== 'Stamps' && uo.reward_type !== 'Vouchers' && uo.value !== 0"
                            class="text-center text-grey font-bold"
                            style="font-size: 16px">
                               ₹{{ uo.value }}</div> -->

                          <div
                            v-if="uo.reward_type === 'Cash' && uo.value !== 0"
                            class="text-center text-grey font-bold"
                            style="font-size: 16px; color: #373535;"
                          >
                            ₹{{ uo.value }}
                          </div>
                          <div
                            v-if="
                              uo.reward_type !== 'Cash' &&
                                uo.value !== 0 &&
                                uo.reward_type !== 'Stamps' &&
                                uo.reward_type !== 'Vouchers'
                            "
                            class="text-center text-grey font-bold"
                            style="font-size: 16px"
                          >
                            {{ uo.value }} {{ uo.reward_type }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="offer-details text-center margin-horizontal-30"
                      >
                        <div
                          class="margin-bottom-5"
                          :style="{
                            color: isDarkTheme ? headingTextColor : '#ffffff'
                          }"
                        >
                          Ref Number: #{{ uo.ref }}
                        </div>
                        <div
                          v-if="uo.scratched_on"
                          :style="{
                            color: isDarkTheme ? headingTextColor : '#ffffff'
                          }"
                        >
                          Earned on: {{ formattedDate(uo.created_at, true) }}
                        </div>
                        <div
                          v-if="
                            uo.scratched_on &&
                              uo.sc_data &&
                              !uo.sc_data.is_expired
                          "
                        >
                          Expiry: {{ uo.sc_data.expiry_date }}
                        </div>
                      </div>
                    </div>

                    <!-- Show Voucher Details When Available -->
                    <div
                      v-if="uo.voucher"
                      style="
                        background-color: #ffffff;
                        width: 100%;
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                        display: flex;
                        flex-direction: column;
                        /* padding-bottom: 10px; */
                        justify-content: space-between;
                      "
                    >
                      <div>
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 10px 20px;
                          "
                        >
                          <h3 class="voucher-title">
                            {{ uo.voucher.card_title }}
                          </h3>
                          <p
                            class="voucher-expire"
                            :class="{ expired: uo.voucher.is_expired }"
                          >
                            {{ uo.voucher.expires_in }}
                          </p>
                        </div>
                        <p
                          style="
                            color: black;
                            margin: 0 !important;
                            font-weight: 700;
                            font-size: 13px;
                            text-align: left;
                            padding: 0px 20px;
                          "
                        >
                          {{ uo.voucher.title }}
                        </p>
                        <p
                          style="
                            color: black;
                            margin: 0 !important;
                            font-weight: 600;
                            font-size: 14px;
                            text-align: left;
                            padding: 0px 20px;
                            margin-top: 5px !important;
                          "
                          v-if="
                            uo.voucher &&
                              uo.voucher.voucher_type === 'default' &&
                              !uo.voucher.is_expired
                          "
                        >
                          Voucher Code
                        </p>
                        <div
                          style="
                            display: flex;
                            width: 40%;
                            border-top-left-radius: 10px;
                            border-bottom-left-radius: 10px;
                            padding: 5px 20px;
                          "
                          v-if="
                            uo.voucher &&
                              uo.voucher.voucher_type === 'default' &&
                              !uo.voucher.is_expired
                          "
                        >
                          <div
                            style="
                              width: 60%;
                              background: #eeeeee;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              color: black;
                              padding: 5px 10px;
                              border-top-left-radius: 20px;
                              border-bottom-left-radius: 20px;
                            "
                          >
                            <p
                              style="
                                margin: 0 !important;
                                font-weight: 600;
                                font-size: 10px;
                              "
                            >
                              {{ uo.voucher.code }}
                            </p>
                          </div>
                          <div
                            :style="{
                              width: '40%',
                              background: isDarkTheme
                                ? buttonBGColor
                                : themeColor,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '5px 10px',
                              borderTopRightRadius: '10px',
                              borderBottomRightRadius: '10px',
                              fontWeight: 600,
                              fontSize: '10px',
                              cursor: 'pointer',
                              color: isDarkTheme ? headingTextColor : '#ffffff'
                            }"
                            @click="copyToClipboard(uo.voucher.code)"
                          >
                            Copy
                          </div>
                          <!-- Toast Notification -->
                          <transition name="fade">
                            <div v-if="showToast" class="toast">
                              Voucher Code copied to clipboard
                            </div>
                          </transition>
                        </div>
                        <p
                          v-if="uo.voucher && uo.voucher.expiry_date"
                          style="
                            color: black;
                            margin: 0;
                            font-weight: 600;
                            font-size: 14px;
                            text-align: left;
                            margin-top: 5px !important;
                            margin-bottom: 0 !important;
                            padding: 0px 20px;
                          "
                        >
                          Expiry Date
                        </p>
                        <p
                          style="
                            color: black;
                            margin: 0;
                            font-weight: 600;
                            font-size: 13px;
                            text-align: left;
                            margin-top: 3px !important;
                            margin-bottom: 0 !important;
                            padding: 0px 20px;
                          "
                        >
                          {{ uo.voucher.expiry_date }}
                        </p>
                        <p
                          style="
                            color: black;
                            margin: 0 !important;
                            font-weight: 600;
                            font-size: 14px;
                            text-align: left;
                            margin-top: 15px !important;
                            padding: 0px 20px;
                          "
                          v-if="uo.voucher && !uo.voucher.is_expired"
                        >
                          Details
                        </p>
                        <div
                          v-if="uo.voucher && !uo.voucher.is_expired"
                          :style="{
                            color: 'black',
                            margin: '0',
                            fontWeight: '700',
                            fontSize: '12px',
                            textAlign: 'left',
                            marginTop: '5px',
                            position: 'relative',
                            padding: '0px 0px 20px 20px'
                          }"
                        >
                          <p
                            style="
                              color: black;
                              margin: 0 !important;
                              font-weight: 600;
                              font-size: 12px;
                              text-align: left;
                            "
                            v-html="
                              formatVoucherDetails(
                                uo.voucher && uo.voucher.details
                              )
                            "
                          ></p>
                        </div>
                      </div>
                      <div
                        v-if="uo.voucher"
                        style="
                          /* background-color: #ffffff; */
                          color: black;
                          width: 100%;
                          padding: 10px 0px;
                          margin-top: 5px;
                        "
                      >
                        <button
                          v-if="
                            uo.voucher &&
                              !uo.voucher.is_expired &&
                              ('is_available' in uo.voucher
                                ? uo.voucher.is_available
                                : true)
                          "
                          :style="{
                            border: 'none',
                            backgroundColor: isDarkTheme
                              ? topBgColor
                              : themeColor,
                            padding: '7px 30px',
                            borderRadius: '20px',
                            color: '#ffffff'
                          }"
                          @click="openRedeemModal(uo)"
                        >
                          Redeem Now
                        </button>
                      </div>
                    </div>
                    <!-- Modal Overlay -->
                    <div
                      v-if="showRedeemModal"
                      style="
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: end;
                        align-items: center;
                        z-index: 9999;
                        flex-direction: column;
                      "
                    >
                      <div
                        style="
                          /* background: white; */
                          border-radius: 10px;
                          width: 100%;
                          text-align: center;
                          padding-top: 5px;
                          border-top-left-radius: 10px;
                          border-top-right-radius: 10px;
                        "
                        :style="{
                          backgroundColor: isDarkTheme
                            ? offersCardBgColor
                            : '#ffffff'
                        }"
                      >
                        <p
                          @click="closeRedeemModal"
                          style="
                            color: black;
                            text-align: right;
                            margin: 0 !important;
                            font-size: 10px;
                            cursor: pointer;
                            padding: 20px;
                            padding-bottom: 10px;
                          "
                        >
                          X
                        </p>
                        <!-- <h3>Redeem Voucher</h3> -->
                        <div style="padding: 20px; padding-top: 0px">
                          <div
                            style="
                              width: 100%;
                              display: flex;
                              flex-direction: column;
                            "
                          >
                            <label
                              for="receiver-name"
                              style="
                                display: block;
                                margin-bottom: 5px;
                                font-weight: 500;
                                font-size: 10px;
                                color: gray;
                                text-align: left;
                              "
                            >
                              Receiver's Name
                            </label>
                            <input
                              id="receiver-name"
                              aria-label="Receiver's Name"
                              type="text"
                              placeholder="Enter Receiver's Name"
                              v-model="redeemName"
                              style="
                                padding: 8px;
                                margin-bottom: 10px;
                                border-radius: 5px;
                                border: 1px solid #ccc;
                              "
                            />
                          </div>
                          <div
                            style="
                              width: 100%;
                              display: flex;
                              flex-direction: column;
                            "
                          >
                            <label
                              for="receiver-email"
                              style="
                                display: block;
                                margin-bottom: 5px;
                                font-weight: 500;
                                font-size: 10px;
                                color: gray;
                                text-align: left;
                              "
                            >
                              Receiver's Email
                            </label>
                            <input
                              id="receiver-email"
                              aria-label="Receiver's Email"
                              type="email"
                              placeholder="Enter Receiver's Email"
                              v-model="redeemEmail"
                              style="
                                padding: 8px;
                                margin-bottom: 10px;
                                border-radius: 5px;
                                border: 1px solid #ccc;
                              "
                            />
                          </div>
                          <button
                            :style="{
                              border: 'none',
                              backgroundColor: isDarkTheme
                                ? buttonBGColor
                                : themeColor,
                              padding: '10px 30px',
                              borderRadius: '20px',
                              color: isDarkTheme ? headingTextColor : 'white',
                              cursor: 'pointer'
                            }"
                            @click="submitRedeem(uo)"
                          >
                            Redeem
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div
          @click="redirectTo('offers')"
          v-if="allUserOffers.length && show_see_offer"
        >
          <button
            class="custom-button small padding-1020 radius-5 pointer"
            :style="{
              background: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
          >
            SEE OFFERS
          </button>
        </div>

        <div
          class="margin-bottom-20"
          v-if="allUserOffers.length == 0 && showShimmer"
        >
          <div
            class="align-hor space-between margin-bottom-20 padding-vertical-10"
            v-for="$i in 1"
            :key="$i"
          >
            <div
              class="wrapper"
              :class="$j < 2 ? 'margin-right-20' : ''"
              v-for="$j in 2"
              :key="$j"
            >
              <div
                :style="
                  windowWidth < 511 ? 'min-height:100px' : 'min-height:90px'
                "
                class="comment shimmer-box animate bg-light-grey"
                v-for="$k in 2"
                :key="$k"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '10px'
        }"
        class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver"
        style="min-height: 70vh"
        v-if="allUserOffers.length == 0 && !showShimmer"
      >
        <img
          class="extra-large-icon margin-bottom-20"
          src="@/assets/no-data.svg"
        />
        <div class="margin-bottom-20">You haven't Earned any Rewards yet!</div>
        <div @click="redirectTo('offers')" v-if="show_see_offer">
          <button
            class="custom-button small padding-1020 radius-5 pointer"
            :style="{
              background: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
          >
            SEE OFFERS
          </button>
        </div>
        <!-- <div
          @click="redirectTo('offers')"
          v-if="allUserOffers.length && show_see_offer"
        >
          <button
            class="custom-button small padding-1020 radius-5 pointer"
            :style="{
              background: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
          >
            SEE OFFERS
          </button>
        </div> -->
      </div>
      <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading"
        ><span slot="no-more"></span
      ></infinite-loading>
    </div>
    <pan-dialog
      :show="showPanDialog"
      @close="showPanDialog = false"
      @success="onPanValidated()"
    />
  </div>
</template>
<script>
import { asset } from "@/utils/asset";
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import ScratchCard from "@/components/scratch-card";
import PanDialog from "@/components/pan-dialog.vue";
import BRUSH from "@/assets/brush.png";
import SCBG from "@/assets/sc-bg-empty-circle.svg";
import SCBG1 from "@/assets/sc-bg.png";
import { isDate } from "moment";
export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    "scratch-card": ScratchCard,
    "pan-dialog": PanDialog
  },
  data() {
    return {
      headerData: {
        onlyHeader: false,
        rewards: true,
        referrals: false
      },
      page: 1,
      allUserOffers: [],
      windowWidth: window.screen.width,
      renderCount: 0,
      cardWidth: 200,
      cardHeight: 200,
      finishPercent: 40,
      brushUrl: BRUSH,
      scBgUrl: SCBG,
      imageUrl: SCBG1,
      imageUrl: SCBG1,
      forceReveal: false,
      placeholder: true,
      is_shimmer: true,
      refer_code: null,
      show_see_offer: false,
      themeColor: "green",
      showRedeemModal: false,
      redeemName: "",
      redeemEmail: "",
      showToast: false,
      textToCopy: "",
      showRedeemToast: false,
      redeemMessageToast: "",
      showPanDialog: false,
      pendingRedeemOffer: null
    };
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("flyyDataSet", self.refreshRewards, false);
    } else {
      window.attachEvent("onflyyDataSet", self.refreshRewards);
    }

    this.loadDataFromCookie();
    this.$store.state.user.show_currency_name = this.rewardsShowCurrencyName;
    this.$store.state.user.show_currency_list = this.rewardsShowCurrencyList;
    this.$store.state.user.show_action_button = this.showActionButtonInRewards;
  },
  computed: {
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    scratchCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.scratchCardBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.scratchCardBgColor;
      }
      return null; // fallback
    },
    scratchCardInnerColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.scratchCardInnerColor
      ) {
        return this.$store.state.sdkEvent.themeColors.scratchCardInnerColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },

    showPlaceHolder: function() {
      return this.placeholder;
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  methods: {
    copyToClipboard(text) {
      if (!text) {
        console.error("No text to copy!");
        return;
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.showToastMessage();
          })
          .catch(err => {
            console.error("Clipboard write failed:", err);
            this.fallbackCopy(text);
          });
      } else {
        this.fallbackCopy(text);
      }
    },

    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        this.showToastMessage();
        this.showRedeemToastMessage();
      } catch (err) {
        console.error("Fallback copy failed:", err);
      }

      document.body.removeChild(textArea);
    },

    showToastMessage() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
    showRedeemToastMessage() {
      console.log("Gift Card Initiated Toast Triggered");
      this.showRedeemToast = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.showRedeemToast = false;
        }, 2000);
      });
    },
    extractTextFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return Array.from(doc.body.children)
        .map(el => el.textContent.trim())
        .join("\n");
    },
    formatVoucherDetails(html) {
      if (!html) return "";

      const isHtml = /<\/?[a-z][\s\S]*>/i.test(html);
      if (!isHtml) {
        return html;
      }

      const doc = new DOMParser().parseFromString(html, "text/html");
      return Array.from(doc.body.children)
        .map(el => el.textContent.trim())
        .join("<br>");
    },
    openRedeemModal(uo) {
      console.log(uo.voucher);
      if (uo.voucher && uo.voucher.voucher_type === "default") {
        window.open(uo.voucher.redemption_url, "_blank");
      } else {
        this.showRedeemModal = true;
      }
    },
    closeRedeemModal() {
      this.showRedeemModal = false;
      this.redeemName = "";
      this.redeemEmail = "";
    },
    submitRedeem(uo) {
      console.log(uo);
      if (this.redeemName && this.redeemEmail) {
        const self = this; // Preserve context
        let url = "";
        let requestBody = {};
        const headers = this.$store.getters.headers; // Retrieve headers from store
        const options = { headers }; // Set headers for the request

        if (
          (uo.voucher && uo.voucher.voucher_type === "gift_card1") ||
          uo.voucher.voucher_type === "rupee" ||
          uo.voucher.voucher_type === "percent"
        ) {
          // API for gift cards
          url = this.$store.getters.flyyDomain + "/v1/buy_gift_cards";
          requestBody = {
            email: this.redeemEmail,
            name: this.redeemName,
            price: uo.value || 1,
            ...(uo.sku && { sku: uo.sku })
          };
          // this.showRedeemModal = false;
        } else {
          // API for other vouchers
          url = this.$store.getters.flyyDomain + "/v1/buy_voucher_gift_cards";
          requestBody = {
            email: this.redeemEmail,
            name: this.redeemName,
            redemption_url: uo.voucher.redemption_url || "", // Redemption URL from voucher
            voucher_num: uo.ref // Voucher number from voucher
          };
          // this.showRedeemModal = false;
        }

        axios
          .post(url, requestBody, options)
          .then(resp => {
            if (resp.status === 200) {
              const data = resp.data;
              console.log("Redeem Response:", data);

              if (data.pan_required) {
                this.pendingRedeemOffer = uo;
                this.showPanDialog = true;
                return;
              }

              if (data.success) {
                this.redeemMessageToast =
                  " 🎉 Gift Card Initiated Successfully!";
              } else {
                this.redeemMessageToast = "Unable to redeem Gift Card";
              }

              this.showRedeemModal = false;
              uo.show_sc = false;

              this.page = 1;
              this.allUserOffers = [];
              this.infiniteHandler();

              this.showRedeemToastMessage();
            } else {
              console.log("Redeem API error:", resp);
              alert("Failed to redeem. Please try again later.");
            }
          })
          .catch(error => {
            console.error("Redeem API error:", error);
            alert("An error occurred while redeeming. Please try again.");
          });
      } else {
        alert("Please fill in all fields.");
      }
    },
    onPanValidated() {
      var uo = this.pendingRedeemOffer;
      this.showPanDialog = false;
      this.pendingRedeemOffer = null;
      if (uo) {
        this.submitRedeem(uo);
      }
    },
    refreshRewards() {
      this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
    },
    onComplete(uo) {
      var ref = uo.ref;
      var url = this.$store.getters.flyyDomain + "/scratch_user_offer/" + ref;
      var headers = this.$store.getters.headers;

      axios
        .put(url, { mode: "no-cors" }, { headers })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            var user_offer = data.user_offer;

            // ✅ Update only reward data, not visibility
            uo.is_scratched = user_offer.is_scratched;
            uo.scratched_on = user_offer.scratched_on;
            uo.voucher = user_offer.voucher;

            // 👇 Don't auto-refresh or auto-hide here
            // this.page = 1;
            // this.infiniteHandler();
          } else {
            console.log("Error fetching the user offers");
          }
        })
        .catch(error => {
          console.log("Catch block", error);
        });
    },
    // onComplete(uo) {
    //   var ref = uo.ref;
    //   var self = this;
    //   var url = this.$store.getters.flyyDomain + "/scratch_user_offer/" + ref;
    //   var headers = this.$store.getters.headers;

    //   var options = {
    //     headers: headers
    //   };

    //   axios
    //     .put(
    //       url,
    //       {
    //         mode: "no-cors"
    //       },
    //       options
    //     )
    //     .then(resp => {
    //       if (resp.status == 200) {
    //         var data = resp.data;
    //         var user_offer = data.user_offer;

    //         // Update uo properties
    //         uo.is_scratched = user_offer.is_scratched;
    //         uo.scratched_on = user_offer.scratched_on;
    //         uo.voucher = user_offer.voucher; // Store voucher details

    //         this.page = 1

    //         self.getBasicAppInfo();
    //         // this.infiniteHandler()
    //       } else {
    //         console.log("Error fetching the user offers");
    //       }
    //     })
    //     .catch(error => {
    //       console.log("Catch block", error);
    //     });
    // },

    showScratchCard(uo) {
      uo.show_sc = true;
    },
    // hideScratchCard(uo) {
    //   // this.page = 1
    //   // this.infiniteHandler()
    //   uo.show_sc = false;
    //   if (
    //     (uo.value === 0 && uo.reward_type !== "Stamps") ||
    //     uo.reward_type !== "Vouchers"
    //   ) {
    //     var index = this.allUserOffers.findIndex(item => {
    //       return item.id == uo.id;
    //     });
    //     // this.allUserOffers.splice(index,1)
    //   }
    // },

    //   hideScratchCard(uo) {
    //   uo.show_sc = false;

    //   // Remove card only if "Better luck next time"
    //   // if (uo.value === 0 && uo.reward_type !== "Stamps" && uo.reward_type !== "Vouchers") {
    //   //   var index = this.allUserOffers.findIndex(item => item.id === uo.id);
    //   //   if (index !== -1) {
    //   //     this.allUserOffers.splice(index, 1);
    //   //   }
    //   // }
    //   if (uo.value === 0 && uo.reward_type === "Cash") {
    //     var index = this.allUserOffers.findIndex(item => item.id === uo.id);
    //     if (index !== -1) {
    //       this.allUserOffers.splice(index, 1);
    //     }
    //   }

    //   // 👉 If reward (value > 0 or Voucher/Stamps), keep it in the list
    // },

    hideScratchCard(uo) {
      uo.show_sc = false;

      // Remove card only if scratched AND "Better luck next time" Cash reward
      if (uo.is_scratched && uo.value === 0 && uo.reward_type === "Cash") {
        var index = this.allUserOffers.findIndex(item => item.id === uo.id);
        if (index !== -1) {
          this.allUserOffers.splice(index, 1);
        }
      }

      // 👉 If reward has value > 0 OR type is Voucher/Stamps, keep it in the list
    },

    // infiniteHandler($state) {
    //   var self = this;
    //   var url = self.$store.getters.flyyDomain + "/v5/user_offers";
    //   var headers = self.$store.getters.headers;

    //   axios
    //     .get(url, {
    //       headers: headers,
    //       params: { page: self.page }
    //     })
    //     .then(resp => {
    //       if (resp.status == 200) {
    //         var data = resp.data;
    //         var user_offers = data.user_offers;
    //         this.themeColor = resp.data.sc_secondary_theme;

    //         if (self.page == 1) {
    //           self.refer_code = data.refer_code;
    //           self.show_see_offer = data.show_see_offer;
    //         }

    //         if (user_offers && user_offers.length) {
    //           self.page += 1;
    //           var tempArr = [];

    //           user_offers.forEach(uo => {
    //             tempArr.push({
    //               show_sc: false,
    //               is_scratched: uo.is_scratched,
    //               scratched_on: uo.scratched_on
    //                 ? uo.scratched_on
    //                 : uo.created_at,
    //               logo: uo.reward_logo,
    //               value: uo.value,
    //               is_available_now: uo.is_available_now,
    //               title: uo.offer_title,
    //               desc: uo.description,
    //               earned_for: uo.message,
    //               ref: uo.ref,
    //               reward_type: uo.reward_type,
    //               reward_logo: uo.reward_logo,
    //               reward_title: uo.reward_title,
    //               id: uo.id,
    //               locked: uo.locked,
    //               unlock_message: uo.unlock_message,
    //               voucher: uo.voucher || null // Store voucher details if available
    //             });
    //           });

    //           self.allUserOffers = [...self.allUserOffers, ...tempArr];
    //           $state.loaded();
    //         } else {
    //           $state.complete();
    //           self.is_shimmer = self.allUserOffers.length > 10;
    //         }
    //       } else {
    //         self.is_shimmer = false;
    //         console.log("Error fetching the user offers");
    //       }
    //     });
    // }
    infiniteHandler($state) {
      var self = this;
      var url = self.$store.getters.flyyDomain + "/v5/user_offers";
      var headers = self.$store.getters.headers;

      axios
        .get(url, {
          headers: headers,
          params: { page: self.page }
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            var user_offers = data.user_offers;
            this.themeColor = resp.data.sc_secondary_theme;

            if (self.page == 1) {
              self.refer_code = data.refer_code;
              self.show_see_offer = data.show_see_offer;
            }

            if (user_offers && user_offers.length) {
              self.page += 1;
              var tempArr = [];

              user_offers.forEach(uo => {
                tempArr.push({
                  show_sc: false,
                  is_scratched: uo.is_scratched,
                  scratched_on: uo.scratched_on
                    ? uo.scratched_on
                    : uo.created_at,
                  created_at: uo.created_at,
                  logo: uo.reward_logo,
                  value: uo.value,
                  is_available_now: uo.is_available_now,
                  title: uo.offer_title,
                  desc: uo.description,
                  earned_for: uo.message,
                  ref: uo.ref,
                  reward_type: uo.reward_type,
                  reward_logo: uo.reward_logo,
                  reward_title: uo.reward_title,
                  id: uo.id,
                  locked: uo.locked,
                  unlock_message: uo.unlock_message,
                  voucher: uo.voucher || null,
                  sc_data: uo.sc_data
                });
              });

              console.log("Tepm - ", tempArr);

              // ✅ If page == 1 (fresh fetch), replace data
              if (self.page === 2) {
                self.allUserOffers = tempArr;
              } else {
                self.allUserOffers = [...self.allUserOffers, ...tempArr];
              }

              // ✅ If called by infinite scroll
              if ($state) $state.loaded();
            } else {
              if ($state) $state.complete();
              self.is_shimmer = self.allUserOffers.length > 10;
            }
          } else {
            self.is_shimmer = false;
            console.log("Error fetching the user offers");
          }
        });

      // console.log("All Offers - ", self.allUserOffers)
    }
  },
  created() {
    this.getBasicAppInfo();
    this.$store.state.showHeader = false;
    this.$store.state.showWallet = false;
    this.$store.state.showHistory = false;
    this.$store.state.headTitle = "Rewards";
  }
};
</script>
<style>
.sc-wrapper {
  display: grid;
  grid-template-columns: repeat(2, minmax(170px, 1fr));
}

@media screen and (min-width: 320px) {
  .sc-wrapper {
    grid-template-columns: repeat(2, minmax(145px, 1fr));
  }
  .point-card-padding {
    padding: 3rem 0;
  }
}

@media screen and (min-width: 768px) {
  .sc-wrapper {
    grid-template-columns: repeat(3, minmax(170px, 1fr));
  }
  .point-card-padding {
    padding: 2rem 0;
  }
}

@media screen and (min-width: 1024px) {
  .sc-wrapper {
    grid-template-columns: repeat(6, minmax(170px, 1fr));
  }
  .point-card-padding {
    padding: 2rem 0;
  }
}

.scratched-reward-icon {
  width: 70px;
}
.card-content {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.sc-all {
  height: 85%;
  min-height: 168px;
  max-height: 168px;
}

.overlay {
  z-index: 9999999 !important;
}

.voucher-title {
  color: black;
  margin: 0 !important;
  font-weight: 700;
  font-size: 19px;
}

.voucher-expire {
  color: red;
  margin: 0 !important;
  font-weight: 600;
  font-size: 12px;
}

.unlock-text-label {
  color: black;
  font-size: 12px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: 5px 0;
  font-weight: 300;
  position: absolute;
  text-align: center;
}

.toast {
  position: fixed;
  bottom: 20px !important;
  left: 50% !important;
  transform: translateX(-50%);
  background: #575656;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 10px;
  opacity: 0.9;
  width: 60% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.expired-tag-sc {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  background: #faf7f7;
}

.expired-text-sc {
  background-color: #e3f7ff;
  /* color: black; */
  color: #373535;
  font-size: 15px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: 10px 0;
  z-index: 1;
  font-weight: 600;
  position: absolute; /* Add this if necessary */
  opacity: 0.5;
  font-weight: 700;
}
</style>
